import loadable from '@loadable/component';

const ComponentShowcasePage = loadable(() => import('./ComponentShowcasePage'));

export { ComponentShowcasePage };
